import { Store } from 'pullstate';

export const PetStore = new Store({
    pets: [],
    initialPetDoc: {
        name: '',
        species: '',
        gender: '',
        neutered: false,
        breed: '',
        identifiers: '',
        microchip: null,
        age: null,
        vetName: '',
        vetAddress: '',
        immunisation: false,
    },
    petDoc: {
        name: '',
        species: '',
        gender: '',
        neutered: false,
        breed: '',
        identifiers: '',
        microchip: null,
        age: null,
        vetName: '',
        vetAddress: '',
        immunisation: false,
    },
    petOnboardingModal: false,
    petOnboardingStep: 0,
});
